import { RESPONSE_CODES } from './constants';
import { OperationErrorData, OperationResultResponse } from './operationRegistry.types';

export const DEFAULT_OPERATION_RETURN = [[undefined, undefined]];
export const getDefaultOperationReturn = (keys: string[]) => {
  const resultObj = Object.fromEntries(keys.map((key) => [key, undefined]));
  return [[undefined, resultObj]];
};

export const returnOperationResult = ({
  status,
  data,
  message,
  errorCode,
  additionalInfo,
}: {
  status: RESPONSE_CODES;
  data: unknown;
  message?: string;
  errorCode?: string;
  additionalInfo?: Record<string, unknown>;
}) => ({
  status,
  data,
  message,
  errorCode,
  additionalInfo,
});

export class OperationError extends Error {
  public cause: unknown;
  public errorCode: string;

  constructor(message: string, errorCode = 'unknown', cause?: unknown) {
    super(message);
    this.name = 'OperationError';
    this.errorCode = errorCode;
    this.cause = cause;

    Object.setPrototypeOf(this, OperationError.prototype);
  }
}

export const throwOperationError = ({
  errorCode,
  message,
  data,
}: {
  errorCode?: string;
  message: string;
  data?: OperationErrorData;
}) => {
  throw new OperationError(JSON.stringify({ message, additionalInfo: data?.additionalInfo }), errorCode, data);
};

export const errorHandler = (error: unknown): OperationResultResponse => {
  let errorMessage = 'An unknown error occurred';
  if (error instanceof Error) {
    errorMessage = error.message;
  }
  return returnOperationResult({
    status: RESPONSE_CODES.ERROR,
    data: DEFAULT_OPERATION_RETURN,
    message: errorMessage,
  });
};
